<template>
<div>
<div v-if="widgetVisible & !controlGroup">
    <div class="widget-container" :class="typeProp" :style="widgetStyle">
      
      <!-- Toggle Float -->

      <div v-if="widgetProp!='' & typeProp=='float' & widgetDisplay" class="toggle-button" @click="toggleMode()" :style="toggleStyle">
          <img v-if="mode=='closed'" :src="imagesURL+'sb-aim.svg'" />
          <img v-if="mode!='closed'" :src="imagesURL+'sb-close.svg'" />
      </div>

      <!-- Toggle Sticky -->

      <div v-if="widgetProp!='' & typeProp=='sticky' & mode != 'closed'" class="toggle-button close-button" @click="mode='closed'"
              :style="toggleStyle">
          <img :src="imagesURL+'sb-close.svg'" />
      </div>

      <!-- Widget Contents -->
      <div v-if="mode != 'closed'" v-show="widgetDisplay" class="panels-container" :style="widgetStyle">
              <welcome-products 
                  v-if="widgetProp=='welcome'" 
                  :sb="sb" 
                  :mode="mode" 
                  :number="numberProp" 
                  :type="typeProp" 
                  :design="widgetStyle"
                  @updateMode="updateMode" 
                  @updateWidgetState="widgetStateChanged" 
                  >
              </welcome-products>
              <similar-products 
                    v-if="widgetProp=='similar'" 
                    :sb="sb" 
                    :productid="productid" 
                    :mode="mode" 
                    :number="numberProp" 
                    :type="typeProp" 
                    :design="widgetStyle"
                    @updateMode="updateMode" 
                    @updateWidgetState="widgetStateChanged" 
                    >
              </similar-products>
              <cross-sell 
                    v-if="widgetProp=='cross_sell'" 
                    :sb="sb" 
                    :productlist="productlist" 
                    :mode="mode" 
                    :number="numberProp" 
                    :type="typeProp" 
                    :design="widgetStyle"
                    @updateMode="updateMode" 
                    @updateWidgetState="widgetStateChanged" 
                    >
              </cross-sell>
              <substitute-product v-if="widgetProp=='substitute'" ></substitute-product>
              <div v-if="mode=='sync'">
                  <sync-device :sb="sb"></sync-device>
              </div>
      </div>


      <!-- Loading indicator -->

      <div v-if="typeProp=='sticky' & mode != 'closed' & widgetState=='loading'" class="panels-container" :style="widgetStyle">
        <div class="loading-grid">
          <div class="loading">
            <h3>Matching</h3>
          </div>
          <div class="loading-icon" :style="toggleStyle">
            <div class="loading-bar" :style="toggleStyle">
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
</div>
</template>

<script>
// import Vuetify from 'vuetify'
// import goTo from 'vuetify/es5/services/goto'
//import VueAxios from 'vue-axios'
// import {HTTP} from '../sbcore/http-common.js'

// import SimilarRow from './SimilarRow';
// import {VApp, VCard} from 'vuetify/lib'
import WelcomeProducts from './WelcomeProducts.vue'
import SimilarProducts from './SimilarProducts.vue'
import CrossSell from './CrossSell.vue'
import SubstituteProduct from './SubstituteProduct.vue'
import SyncDevice from './SyncDevice.vue'
import SB from '../sbcore/sbsdk.js'
// import RecentHistory from './RecentHistory.vue'

let site = require(process.env.VUE_APP_SITE_JS)

// import Vue from 'vue'


// First if this a a sync then just grab the UUID and Flags and redirect
  let sbPixel = new(SB)
  let parts = sbPixel.getUrlVars(window.location)
  if (parts['shopbox_sync'] != undefined) {
    localStorage.shopbox_uuid=parts['shopbox_sync']
    if (parts['r'] != undefined) {window.location=parts['r']}
  }

export default {
  // components: {VApp, VCard},
  // components: {SimilarRow,VApp, VCard},
  components : {WelcomeProducts,SimilarProducts,SyncDevice,CrossSell,SubstituteProduct},
  props : {
    'name' : String,
    'widget' : String,
    'type' : {
      type : String,
      default : 'float' 
    },
    'product' : {
      type :  String,
      default : '',
    },
    'productlist' : {
      type :  String,
      default : '',
    },    
    'design' : {
      type : String,
      default : 'float' 
    },
    'position' : {
      type : String,
      default : 'bottom_left'
    },
    // 'toggle' : {
    //   type : String,
    //   default : 'toggleButton'
    // },
    'sync' : {
      type : String,
      default : 'syncButton'
    },
    'number' : {
      type : Number,
      default : 3
    }
  },
  data: () => ({
    imagesURL : site.imagesURL,
    mode : '',
    page : {},
    productid : '',
    // displayReady : false,
    controlGroup : true,
    widgetState : 'hide',
    widgetProp : '',
    typeProp : '',
    designProp : '',
    positionProp : '',
    numberProp : ''
  }),
  methods : {
    // displayReadyChanged(args) {
    //   this.displayReady = args
    // },
    widgetStateChanged(args) {
      this.widgetState = args
    },
    fetchProduct () {
      // Product can have a leading space. Basically the pixel inserts one to signify a change in product, if the same product has been selected a second time
      if (this.product[0]==' ') {
        return this.product.substring(1)
      } else {
        return this.product
      }
    },
    updateMode(args) {
      if (this.typeProp=='inpage') {
        this.mode='big'
      } else {
        if (args.length>0) {
          this.setMode(args)
        }
      }
    },
    toggleMode() {
      this.mode = (this.mode=='closed') ? 'small' : 'closed'

      let data = {
        'sbAction' : 'Disc-'+this.mode,
        'productid' : this.productid,
        'source' : this.widgetProp + '_' + this.typeProp,
        'page' : window.location.pathname+window.location.search
      }
      this.sb.sendEvent('sbaction',data)
    },
    setMode(newMode) {
      if (this.typeProp=='sticky' | this.typeProp=='inpage') {
        this.mode='big'
      } else {
        this.mode=newMode
      }
    },
  },
  created () {

    if (site.debug) {
      console.log('SB Created',localStorage.key(0))
    }


    this.sb = new SB()

    this.sb.init((controlGroup)=> {
      if (site.debug) {console.log('Control Group returned',controlGroup)}
      if (!site.badUUID(this.sb.uuid) && !site.badDomain()) {
        this.controlGroup = controlGroup==1
      } else {
        this.controlGroup = true
      }
    })


    if (site.debug) {
      console.log('ControlGroup',this.controlGroup)
    }

    // console.log('here',this.name,site.widgets,site.widgets[this.name].widget)

    if (this.name != '' && this.name != undefined) {
        let name = ''
        if (this.sb.smallScreen()) {
          name = this.name + '_mobile'
        } else {
          name = this.name
        }
        this.widgetProp  = site.widgets[name].widget;
        this.typeProp  = site.widgets[name].type;
        this.designProp  = site.widgets[name].design;
        this.positionProp  = site.widgets[name].position;
        this.numberProp  = site.widgets[name].number;
    } else {
        this.widgetProp  = this.widget;
        this.typeProp  = this.type;
        this.designProp  = this.design;
        this.positionProp  = this.position;
        this.numberProp  = this.number //site.widgets[this.name].number;
    }


    // Small screen means 100% wide - use all of it.
    // #1# if (this.sb.smallScreen()) {
    //   this.numberProp = site.widgets[this.name].mobileNumber
    // }


    if (this.sb.smallScreen()) {
      let panelWidth = (site[this.designProp].mobilePanelWidth == undefined) ? 90 : site[this.designProp].mobilePanelWidth;
      this.numberProp = Math.min(this.numberProp,Math.floor((window.screen.width - 110) / panelWidth))
      if (site.sitecode=='did') {
        // The position needs to be looked up until they are updagraded to V3
        this.positionProp = 'bottom_mobile'
      }
    }

    if (this.widgetProp==undefined) {console.log('ERROR: widgetProp undefined')}
    if (this.typeProp==undefined) {console.log('ERROR: typeProp undefined')}
    if (this.designProp==undefined) {console.log('ERROR: designProp undefined')}
    if (this.positionProp==undefined) {console.log('ERROR: PositionProp undefined')}

    if (site.debug) {
        console.log('this.widgetProp',this.widgetProp)
        console.log('this.typeProp',this.typeProp)
        console.log('this.designProp',this.designProp)
        console.log('this.positionProp',this.positionProp)
        console.log('this.numberProp',this.numberProp)
    }

    let pageType = site.pageType()

    if (this.product != '' ) {
      // this.productid = this.product
      this.productid = this.fetchProduct()
    } else if (pageType =='detail') {
        this.productid = site.detailProduct()

    }


    this.setMode('small')   // It will set small or if an inpage, big

   },
  computed : {
    widgetDisplay : function () {
      // Sticky reports issues so should be displayed
      return (['display','nomore','loading'].indexOf(this.widgetState) > -1 || this.typeProp=='sticky')
    },
    widgetStyle : function () {


      // Define where the toggle will go based on toggle_position
      // Default to top_right
      let togglePadding = "0 35px 35px 35px"
      if (this.typeProp=='sticky') {togglePadding = "0 35px 0 0"}
      let toggleTop = '25px'
      let toggleBottom = 'auto'
      let toggleLeft = 'auto'
      let toggleRight = '25px'
      let widgetAreas = '". . toggle" ". panels ."'

      if (site[this.positionProp].togglePosition == 'top_left') {
        togglePadding = "0 35px 35px 35px "
        toggleTop = '25px'
        toggleBottom = 'auto'
        toggleLeft = '-20px'
        toggleRight = 'auto'
        widgetAreas = '"toggle . ." ". panels ." '
      
      } else if (site[this.positionProp].togglePosition == 'bottom_left') {
        togglePadding = "35px 35px 0 35px"
        toggleTop = 'auto'
        toggleBottom = '20px'
        toggleLeft = '-20px'
        toggleRight = 'auto'
        widgetAreas = '". panels ." "toggle . ." '

      } else if (site[this.positionProp].togglePosition == 'bottom_right') {
        togglePadding = "35px 35px 0 35px"
        toggleTop = 'auto'
        toggleBottom = '20px'
        toggleLeft = 'auto'
        toggleRight = '20px'
        widgetAreas = '". panels ." ". . toggle" '
      } else if (site[this.positionProp].togglePosition == 'bottom_center') {
        togglePadding = "35px 35px 0 0"
        toggleTop = 'auto'
        toggleBottom = '10px'
        toggleLeft = 'auto'
        toggleRight = 'auto'
        widgetAreas = '". panels ." ". toggle ." '
      } else if (site[this.positionProp].togglePosition == 'top_center' || this.sb.smallScreen()) {
        togglePadding = "15px 25px 0 0"
        toggleTop = '5px'
        toggleBottom = '10px'
        toggleLeft = '50%'
        toggleRight = '50%'
        widgetAreas = '". toggle ." ". panels ." '
      } else if (site[this.positionProp].togglePosition == 'center_left') {
        togglePadding = "35px 35px 0 35px"
        toggleTop = 'auto'
        toggleBottom = '25px'
        toggleLeft = '-20px'
        toggleRight = 'auto'
        widgetAreas = '"toggle panels"'
      } else if (site[this.positionProp].togglePosition == 'center_right') {
        togglePadding = "35px 50px 0 35px"
        toggleTop = 'auto'
        toggleBottom = '-25px'
        toggleRight = '0px'
        toggleLeft = 'auto'
        widgetAreas = '"panels panels toggle"'
      }
      return {
        '--background-color' : site[this.designProp].backgroundColor,
        '--controls-color' : site[this.designProp].controlsColor,
        '--border' : site[this.designProp].borderLine + ' ' + site[this.designProp].discColor,
        '--border-radius' : site[this.designProp].borderRadius,
        '--box-shadow' : site[this.designProp].boxShadow,
        '--box-shadow-hover' : site[this.designProp].boxShadowHover,
        '--z-index' : site[this.designProp].zIndex,
        '--image-height' : (this.sb.smallScreen()) ? site[this.designProp].mobileImageHeight :site[this.designProp].imageHeight,
        '--image-width' : (this.sb.smallScreen()) ? site[this.designProp].mobileImageWidth : site[this.designProp].imageWidth,
        '--icon-height' : site[this.designProp].iconHeight,
        '--icon-width' : site[this.designProp].iconWidth,
        
        '--top' : site[this.positionProp].top,
        '--bottom' : site[this.positionProp].bottom,
        '--left' : site[this.positionProp].left,
        '--right' : site[this.positionProp].right,

        // '--areas' : site[this.position].areas,
        '--product-areas' : site.productAreas,
        '--icon-columns' : site[this.positionProp].orientation=='vertical' ? 'auto' : 'repeat('+this.numberProp+', auto)',
        // '--number' : this.numberProp,      // Number of columns / products
        '--number' : Math.min(this.numberProp,Math.floor(window.innerWidth / 160)),

        '--areas' : widgetAreas,
        '--toggle-padding' : togglePadding,
        '--toggle-top' : toggleTop,
        '--toggle-bottom' : toggleBottom,
        '--toggle-left' : toggleLeft,
        '--toggle-right' : toggleRight,

        '--panels-width' : '100px'

      }
    },
    toggleStyle : function () {
      return {
        '--background-color' : site[this.designProp].discColor,
        '--box-shadow' : site[this.designProp].boxShadow,
        '--box-shadow-hover' : site[this.designProp].boxShadowHover,
        '--z-index' : site[this.designProp].zIndex,
        '--margin' : site[this.designProp].shadowSpace,
      }
    },


    widgetVisible : function () {


      if (site.debug) {
        console.log('AvailableWidgets',this.name,this.sb.smallScreen(),site.availableWidgets,site.availableMobileWidgets,(this.typeProp=='sticky' && (['similar','cross_sell','substitute'].indexOf(this.widgetProp) > -1 & this.productid != '')))
      }

      // if (site.availableWidgets.indexOf(this.widgetProp) > -1) {
      if ((!this.sb.smallScreen() && site.availableWidgets.indexOf(this.name) > -1) || (this.sb.smallScreen() && site.availableMobileWidgets.indexOf(this.name) > -1)) {
        return (this.typeProp=='sticky' && (['similar','cross_sell','substitute'].indexOf(this.widgetProp) > -1 & this.productid != '')) || this.typeProp!='sticky'

      } else {
        // console.log('Widget not supported: ',this.widget)
        return false
      }
      // return (this.type=='sticky' && (this.widget=='similar' & this.productid != '')) || this.widget=='welcome' || this.type=='float'
    }

    // widgetVisible : function () {
    //   if (this.type = 'sticky') {
    //     return (this.widget=='similar' & this.productid != '')
    //   } else if (this.type == 'float') {

    //   } else {
    //     return true
    //   }
    //   return (this.type=='sticky' && (this.widget=='similar' & this.productid != '')) || this.type!='sticky'
    //   // return (this.type=='sticky' && (this.widget=='similar' & this.productid != '')) || this.widget=='welcome' || this.type=='float'
    // }


  },
  watch : {
    product: function  () {

      if (site.debug) {
        console.log('Shopbox product changed',this.product,this.controlGroup)
      }
      // this.productid = this.product;
      this.productid = this.fetchProduct();
      // this.displayReady = false;
      if (this.mode=="closed") {
        this.mode='big'
      }
    }
  }
};
</script>
<style scoped>

.float {
  position : fixed;
  transition: 'all 0.01s linear';
  overflow : hidden;
}
.sticky {
  position : fixed;
  transition: 'width 0.01s, height 0.01s';
  overflow : hidden;
}
.sticky:hover{
  box-shadow : 0px 0px 10px 1px var(--hover-shadow-color);
}
.inpage {
  overflow : hidden;
}

@media only screen and (max-width: 768px) {
  .widget-container {
    max-width: 100%; 
  }
}


.widget-container {
  /*border : 2px red dashed;*/
  top : var(--top);
  bottom : var(--bottom);
  left : var(--left);
  right : var(--right);
  padding : var(--toggle-padding);        
  width : min-content;
  z-index : var(--z-index);
  display: grid;
  grid-template-columns: 5px auto 5px ;
  grid-template-rows : auto;
  grid-template-areas: var(--areas);
  /*padding : 10px;*/
/*  ". panels ."
  "toggle . ."
*/              ;
}

@media only screen and (max-width: 768px) {
.widget-container {
   width : 99%;  /* #1# */
}
}


.toggle-button {
  position : relative;            
  top : var(--toggle-top);            
  bottom : var(--toggle-bottom);            
  left : var(--toggle-left);            
  right : var(--toggle-right);            
  width : 50px;             
  height : 50px;            
  /*margin : var(--margin);*/
  grid-area : toggle;
  cursor : pointer;
  border-radius: 50%;
  display : grid;
  justify-content: center;
  align-items: center;
  background-color : var(--background-color);
  box-shadow : var(--box-shadow);
  z-index : var(--z-index);
}

.toggle-button:hover {
  box-shadow: var(--box-shadow-hover);
}

.toggle-button img {
width : 36px;
}

.close-button img {
  right : 0px;
}

.panels-container {
  grid-area : panels;
  background-color: var(--background-color);
  border : var(--border);
  border-radius : var(--border-radius);
  box-shadow : var(--box-shadow);
  padding-top : 5px;
  padding-right: 1px;
  max-width: 100%;
}

.panel-container:hover {
  box-shadow : var(--box-shadow-hover)
}

.loading {
  width : 100%;
  white-space: nowrap;
  margin-left : 50px;
  margin-right : 50px;
}

.loading h3 {
  margin-bottom : 0px;
  margin-top : 0px;
}
/* 
@keyframes example {
  1% : {background-color : red;}
  50% : {background-color : blue;}
  100% : {background-color : yellow;}
}

#loading-icon {
  margin-left : 50px;
  margin-right : 50px;
  background-color: black ; var(--background-color);
  height : 10px;
  margin-bottom : 10%;
  animation: example 0.5s;
} */


@keyframes progress_bar {
  0%   {width:10%;}
  10%   {width:10%;}
  20%  {width:20%;}
  30%   {width:30%;}
  40%   {width:40%;}
  50%  {width:50%;}
  60%   {width:60%;}
  70%  {width:70%;}
  80%   {width:80%;}
}

.loading-icon {
  border : 1px solid var(--background-color);
  border-radius : 10px;
  margin-left : 10%;
  margin-right : 10%;
  margin-bottom : 5px;
  height: 10px;
  width : 80%;
}

.loading-bar {
  background-color: var(--background-color);
  position: relative;
  height: 10px;
  border-radius : 5px;
  animation-name: progress_bar;
  animation-duration: 2s;
  animation-iteration-count: 200;
}



</style>